import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Button } from "simple-ui-components";

import PublishIcon from "@mui/icons-material/Publish";

import { getTranslation } from "../languageProvider";

const UploadPDF = ({ labelName, Uploaded, error, accept, clear }) => {
  const inputElement = useRef(null);
  const [getError, setGetError] = useState(false);
  const [errorOnImageSize, setErrorOnImageSize] = useState(false);

  // clear uploaded document
  useEffect(() => {
    setGetError(error);
    let file = document.querySelector(".file");
    file.value = null;
  }, [error, clear]);

  return (
    <InputWrapper error={getError}>
      <Button
        theme="default"
        type="button"
        clicked={() => {
          inputElement.current.click();
        }}
        className="btn-secondary widthFixed"
      >
        <PublishIcon /> {labelName}
        <input
          style={{ display: "none" }}
          type="file"
          ref={inputElement}
          onChange={(event) => {
            if (event.target.files.length > 0) {
              let fileSize = (event.target.files[0].size / 1024 / 1024).toFixed(
                2
              );
              if (fileSize < 5) {
                Uploaded(event);
              } else {
                setErrorOnImageSize(true);
              }
            }
          }}
          accept={accept}
          className={getError ? "error file" : "file"}
        />
      </Button>
      {errorOnImageSize && (
        <div className="sizeError" data-translate="0269">
          {getTranslation("0166")}
        </div>
      )}
    </InputWrapper>
  );
};
export default UploadPDF;
const InputWrapper = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
    position: relative;
    width: 100%;
    padding-bottom: ${current.gLG};

    button {
      width: 100%;
      outline: 0;
      border-width: 1px;
      border-style: solid;
      transition: box-shadow 150ms ease-out;
      position: relative;
      padding: ${current.gMD};
      height: 42px;

      border-color: rgba(${current.black},0.0625);
      background: rgb(${current.white});
      border-radius: 4px;
    }

    .sizeError {
      color: rgb(${current.red});
    }
    .uploadedImage {
      margin-top: ${current.gSM};
      margin-bottom: ${current.gSM};
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: ${current.gSM};
      color: rgb(${current.black});
      border:1px solid rgba(${current.black}, 0.0625);
    }

      .clearUploadedImage{
      color:rgb(${current.red});
    }

    ${
      props.error &&
      ` *{
          color: rgb(${current.red})!important;
        }
    `
    };
  `;
  }}
`;
